"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _typeValidation = _interopRequireDefault(require("./typeValidation"));
var _html = require("@citrus/html");
var _PctyQuestion = require("./PctyQuestion.Common");
var PctyQuestionSectionParagraph = function PctyQuestionSectionParagraph(_ref) {
  var id = _ref.id,
    content = _ref.content;
  return /*#__PURE__*/_react.default.createElement(_html.Html, {
    content: (0, _PctyQuestion.replaceEmptyPTags)(content),
    id: id + '-paragraph'
  });
};
PctyQuestionSectionParagraph.propTypes = {
  /** The text to display for the component. */
  content: _propTypes.default.string.isRequired,
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  __TYPE: function __TYPE(props, propName, componentName) {
    return (0, _typeValidation.default)(props, propName, componentName, 'PctyQuestionSectionParagraph');
  }
};
PctyQuestionSectionParagraph.defaultProps = {
  __TYPE: 'PctyQuestionSectionParagraph'
};
var _default = exports.default = PctyQuestionSectionParagraph;